import { Component, inject, signal } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { AmplifyAuthenticatorModule, AuthenticatorService } from '@aws-amplify/ui-angular';

@Component({
  selector: 'app-root',
  imports: [AmplifyAuthenticatorModule, RouterLink, RouterLinkActive, RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App {
  protected readonly authenticator = inject(AuthenticatorService);

  protected readonly authFallbackVisible = signal<boolean>(false);
  protected readonly authErrorMessage = signal<string | null>(null);
  protected readonly authLoadingVisible = signal<boolean>(true);
  private authSubscription?: ReturnType<AuthenticatorService['subscribe']>;

  constructor() {
    this.setupAuthFallback();
  }

  protected signIn(): void {
    this.authenticator.toSignIn();
  }

  protected signOut(): void {
    this.authenticator.signOut();
  }

  protected resetAuth(): void {
    localStorage.clear();
    sessionStorage.clear();
    window.location.reload();
  }

  private setupAuthFallback(): void {
    this.authSubscription = this.authenticator.subscribe(() => {
      const error: any = this.authenticator.error;
      if (error) {
        const message = typeof error === 'string' ? error : error.message || 'Sign-in failed.';
        this.authErrorMessage.set(message);
        this.authFallbackVisible.set(true);
        this.authLoadingVisible.set(false);
      } else {
        this.authErrorMessage.set(null);
      }

      if (this.authenticator.authStatus === 'authenticated') {
        this.authFallbackVisible.set(false);
        this.authLoadingVisible.set(false);
      }
    });

    setTimeout(() => {
      if (this.authenticator.authStatus !== 'authenticated') {
        this.authLoadingVisible.set(false);
        this.authFallbackVisible.set(true);
      }
    }, 4000);
  }
}
